import React, { useRef } from "react";
import { Modal, Form, Row, Col } from "antd";
import { Button, Input } from "antd";
import Axios from "../../../api/Axios";
import { CloseOutlined, FormOutlined } from "@ant-design/icons";
import { useEffect } from "react";
import DynamicSelect from "../customHooks/DynamicSelect";
const AddEditRoles = ({
  visible,
  onCancel,
  modalData,
  CreateSuccessfull,
  CreateFailed,
  id,
  edit = true, // Assuming this is always true for adding roles
}) => {
  console.log(modalData, edit);
  //console.log(modalData?.code);
  //console.log(modalData.title);
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const onFinish2 = async (values) => {
    const payload = {
      ...values,
      type: "work_role",
      organization: id,
    };
    console.log(payload);
    try {
      await Axios.post(`/learn/workrole/`, payload, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      handleCancel();
      CreateSuccessfull("Added");
    } catch (err) {
      //console.log(err);
      CreateFailed("Added");
    }
  };
  const onFinishEdit = async (values) => {
    const payload = {
      ...values,
      type: "work_role",
      organization: id,
    };
    try {
      await Axios.put(`/learn/workrole/?id=${modalData?.id}`, payload, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      handleCancel();
      CreateSuccessfull("Edited");
    } catch (err) {
      //console.log(err);
      CreateFailed("Edited");
    }
  };
  const handleCancel = () => {
    formRef.current.resetFields();
    onCancel();
  };

  const formRef = useRef();
  const loadForm = React.useCallback(() => {
    if (edit && formRef.current) {
      const formValues = {
        role_id: modalData?.role_id,
        job_category: modalData?.job_category,
        job_group: modalData?.job_group,
        location: modalData?.location?.id || null,
        name: modalData?.name,
        description: modalData?.description,
      };
      formRef.current.setFieldsValue(formValues);
    }
  }, [edit, modalData]);
  useEffect(() => {
    if (modalData && formRef.current) {
      loadForm();
    }
  }, [modalData, loadForm]);
  return (
    <Modal
      title={<p className="modal-heading">Add Work Role</p>}
      centered
      // open={modalOpen}
      // onOk={() => setModalOpen(false)}
      // onCancel={() => setModalOpen(false)}
      width={900}
      open={visible}
      onCancel={handleCancel}
      footer={[]}
    >
      <Form
        onFinish={edit ? onFinishEdit : onFinish2}
        name="complex-form"
        labelCol={{
          span: 25,
        }}
        wrapperCol={{
          span: 80,
        }}
        ref={formRef}
        layout="vertical"
        style={{
          width: "100%",
          marginTop: "3rem",
        }}
      >
        <div className="group1" style={{ padding: "0rem" }}>
          <div className="antd-test-client" style={{ marginTop: "2rem" }}>
            <Row gutter={20} style={{ marginLeft: "2rem" }}>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <Form.Item label={<p className="my-form-lables">Role ID</p>}>
                  <Form.Item
                    name="role_id"
                    noStyle
                    rules={[{ required: true, message: "ID is required" }]}
                  >
                    <Input
                      className="my-form-input-antd-test"
                      placeholder="Enter ID"
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <Form.Item label={<p className="my-form-lables">Role Name</p>}>
                  <Form.Item
                    name="name"
                    noStyle
                    rules={[{ required: true, message: "name is required" }]}
                  >
                    <Input
                      className="my-form-input-antd-test"
                      placeholder="Enter name"
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <Form.Item
                  label={<p className="my-form-lables">Job Category</p>}
                >
                  <Form.Item name="job_category" noStyle>
                    <Input
                      className="my-form-input-antd-test"
                      placeholder="Enter category"
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <Form.Item label={<p className="my-form-lables">Job Group</p>}>
                  <Form.Item name="job_group" noStyle>
                    <Input
                      className="my-form-input-antd-test"
                      placeholder="Enter group"
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={16} lg={16} xl={16}>
                <DynamicSelect
                  name="location"
                  label="Location"
                  url={`locationlist/${id}/`}
                  initialValue={modalData?.location}
                />
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Form.Item
                  label={<p className="my-form-lables">Description</p>}
                >
                  <Form.Item name="description" noStyle>
                    <Input.TextArea
                      className="my-form-input-antd-test"
                      placeholder="Enter role description"
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
            </Row>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            height: "2rem",
            marginTop: "1rem",
          }}
        >
          <Form.Item style={{ marginRight: "1rem" }}>
            <Button key="back" onClick={handleCancel}>
              <CloseOutlined />
              Cancel
            </Button>
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              style={{
                background: "#f58029",
                // fontWeight: "600",
              }}
              className="save-update-btn"
            >
              {edit ? "Update" : "Save"}
              <FormOutlined />
            </Button>
          </Form.Item>
        </div>
      </Form>
    </Modal>
  );
};

export default AddEditRoles;
